


import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: {
          "titulo": "🐟 Cardúmenes: Planificá tu estrategia y Dominá las profundidades.",
          "descripcion":  `En <strong>Cardúmenes</strong>, dos jugadores se enfrentan en un tablero submarino donde el <strong>posicionamiento</strong>, <strong>la gestión de Energía</strong> y la <strong>estrategia táctica</strong> definen la partida. Desplegá tus unidades, rompé las líneas enemigas y controlá el ritmo de la partida.<br /><br />🎯 <strong>¿El objetivo?</strong><br />Capturá al <strong>Hipocampo rival</strong> y escoltalo hasta tu base… o superá a tu oponente demostrando una supremacía táctica clara en el campo de batalla.<br /><br />⚡ <strong>Decisiones con costo real</strong><br />Cada turno obtenés Energía al tirar los dados, y debés decidir cómo usarla: mover unidades, atacar, activar habilidades o jugar cartas. No hay acciones gratuitas y cada jugada cuenta.<br /><br />🧠 <strong>Lectura del tablero y control del espacio</strong><br />Empujes, embestidas, parálisis y otras habilidades convierten cada casillero en una amenaza. Una mala ubicación puede costarte una unidad; una jugada precisa puede definir la partida.<br /><br />🃏 <strong>Una capa extra de profundidad</strong><br />Un mercado que ofrece modificadores y efectos especiales que amplían las posibilidades tácticas a cambio de tus valiosos puntos de Energía. No es imprescindible, pero quien aprenda a usarlo hará su Juego aún más poderoso.<br /><br />⚠️ <strong>No gana quien más avanza, sino quien entiende cómo hacerlo estratégicamente.</strong>`,
                  "manual": "¿Querés leer el manual?",
                  "manualbtn": "Ver Manual",
                  "titulovideo": "Cardúmenes en Acción: Como se juega",
                  "descvideo": "Te Contamos Como Jugar",
                   "callactiontitulo": `¿Listo para Dominar el Océano? <br/> ¡Conseguí tu Cardúmenes hoy!`,
                   "callactionbtn1": "Ir a la Tienda",
                   "callactionbtn2": "Venta Mayorista",
                   "preguntasfrecuentestitulo": "Preguntas Frecuentes",

                   "faq_items": [
                      {
                        "question": "¿Para cuántas personas es Cardúmenes?",
                        "answer": "Cardúmenes está diseñado exclusivamente para 2 jugadores."
                      },
                       {
                        "question": "¿Cuánto dura una partida?",
                        "answer": "En promedio, una partida dura entre 25 y 45 minutos."
                      },
                      {
                        "question": "¿Es apto para todas las edades?",
                        "answer": " El juego está recomendado para adultos mayores de 14 años. No tiene contenido inapropiado, pero requiere táctica, planificación y estrategia."
                      },
                      {
                        "question": "¿Qué incluye la caja del juego?",
                        "answer": "El juego incluye 116 cartas: 2 Mazos (Azul y Verde) idénticos de 40, 32 Cartas de Mercado, 4 Cartas de Aturdir / Paralizar. y dos dados D4."
                      },
                       {
                        "question": "¿Donde puedo conseguirlo?",
                        "answer": "Podés comprar Cardúmenes en nuestra tienda online."
                      },
                      
                    ],

                    "frasefooter": "Estrategia, despliegue y captura en las profundidades",
                    "copiright": "Todos los derechos reservados.",
                     "modalmayoristatitutlo": "Venta Mayorista",
                     
                     // En tu i18n.js
"wholesale": {
  "greeting": "¡Hola! ¿Cómo estás?",
  "question": "¿Querés vender <em>Cardúmenes</em> en tu tienda?",
  "register": "Registrate en nuestra tienda mayorista y hacé tu pedido!",
  "whatsapp": "Para que puedas comenzar a operar tenemos que aprobar tu registro, para acelerar el proceso escribinos por Whatsapp."
},
       
 "modalmayoristabtn": "Ir a la Tienda Mayorista",
            

                   
                
        }
      },
      en: {
        translation: {
          "titulo": "🐟 Cardúmenes: Plan your strategy. Rule the depths.",
          "descripcion": `In <strong>Cardúmenes</strong>, two players face off on an underwater board where <strong>positioning</strong>, <strong>Energy management</strong>, and <strong>tactical strategy</strong> define the game. Deploy your units, break enemy lines, and control the rhythm of the battle.<br /><br />🎯 <strong>The Objective?</strong><br />Capture the <strong>rival Seahorse</strong> and escort it to your base… or outmaneuver your opponent by demonstrating clear tactical supremacy on the battlefield.<br /><br />⚡ <strong>Decisions with real cost</strong><br />Each turn you gain Energy by rolling the dice, and you must decide how to spend it: move units, attack, activate abilities, or play cards. There are no free actions, and every move counts.<br /><br />🧠 <strong>Board reading and space control</strong><br />Pushes, dashes, paralysis, and other abilities turn every tile into a threat. A poor position can cost you a unit; a precise play can win the game.<br /><br />🃏 <strong>An extra layer of depth</strong><br />A market that offers modifiers and special effects to expand tactical possibilities in exchange for your valuable Energy points. It's not essential, but those who learn to use it will make their Gameplay even more powerful.<br /><br />⚠️ <strong>Winning isn't about moving forward the most, but about understanding how to do it strategically.</strong>`,
          "manual": "Want to check out the rulebook? (Spanish only)",
          "manualbtn": "View Rules",
          "titulovideo": "Cardúmenes in Action: How to play",
          "descvideo": "Here’s How to Play",
          "callactiontitulo": "Ready to Dominate the Ocean? <br/> Get your Cardúmenes today!",
          "callactionbtn1": "Shop (Argentina Only)",
          "callactionbtn2": "For Retailers",
          "preguntasfrecuentestitulo": "Frequently Asked Questions",

         "faq_items": [
      {
        "question": "How many people is Cardúmenes for?",
        "answer": "Cardúmenes is exclusively designed for 2 players."
      },
      {
        "question": "How long does a match last?",
        "answer": "On average, a match lasts between 25 and 45 minutes."
      },
      {
        "question": "Is it suitable for all ages?",
        "answer": "The game is recommended for players aged 14 and up. It contains no inappropriate content, but requires tactics, planning, and strategy."
      },
      {
        "question": "What’s included in the box?",
        "answer": "The game includes 116 cards: 2 identical 40-card decks (Blue and Green), 32 Market Cards, 4 Stun / Paralyze Cards, and two D4 dice."
      },
      {
        "question": "Where can I get it?",
        "answer": "You can purchase Cardúmenes at our online store."
      }
    ],

        "frasefooter": "Strategy, deployment, and capture in the depths",
        "copiright": "All rights reserved",
        "modalmayoristatitutlo": "Become a Retailer",

      
"wholesale": {
  "greeting": "Hi! How are you?",
  "question": "Do you want to sell <em>Cardúmenes</em> in your store?",
  "register": "Register in our wholesale store and place your order!",
  "whatsapp": "To start operating, we need to approve your registration. To speed up the process, write to us on WhatsApp."
},

 "modalmayoristabtn": "Wholesale (Argentina Only)",


        }
      }
    },
    lng: "es", // Idioma por defecto
    fallbackLng: "es",
    interpolation: { escapeValue: false }
  });

export default i18n;